import React, { useState } from "react";
import { auth, firestore, storage } from "./firebase";
import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
} from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "./Signup.css";
import profileImag from "./assets/google.svg";
import Veri from "./assets/VerifiedTransaction.png";
import EmailIcon from "./assets/emailShape.svg";
import PassIcon from "./assets/passwordIcon.svg";
import Human from "./assets/UserIcon.svg";
import Emailer from "../src/assets/SignUpIcon/creditCard.svg";
import Receipt from "../src/assets/SignUpIcon/reciept.svg";
import FileMoney from "../src/assets/SignUpIcon/filesMoney.svg";
import Keyy from "../src/assets/SignUpIcon/key.svg";
import Verii from '../src/assets/SignUpIcon/veri.png';
import Lock from '../src/assets/SignUpIcon/unlock.svg';

const Signup = () => {
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [securityQuestions, setSecurityQuestions] = useState(["", ""]);
  const [securityAnswers, setSecurityAnswers] = useState(["", ""]);
  const [profileImage, setProfileImage] = useState(null);
  const [pin, setPin] = useState(["", "", "", ""]);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const navigate = useNavigate();
  const provider = new GoogleAuthProvider();

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      let profileImageUrl = "";
      if (profileImage) {
        const imageRef = ref(storage, `profileImages/${user.uid}`);
        await uploadBytes(imageRef, profileImage);
        profileImageUrl = await getDownloadURL(imageRef);
      }
      await setDoc(doc(firestore, "users", userCredential.user.uid), {
        username,
        email,
        securityQuestions,
        securityAnswers,
        pin: pin.join(""),
        profileImageUrl,
        balance: 0,
        transactions: [],
      });
      setShowModal(true);
      setModalMessage("You have been successfully issued an account");
      navigate("/verify-pin");
    } catch (error) {
      console.error("Error during signup:", error);
      setShowModal(true);
      setModalMessage(error.message);
    }
  };

  const handleGoogleSignup = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      console.log("Google sign-in result:", result);

      let profileImageUrl = user.photoURL || "";
      await setDoc(doc(firestore, "users", user.uid), {
        username: user.displayName,
        email: user.email,
        securityQuestions,
        securityAnswers,
        pin: pin.join(""),
        profileImageUrl,
        balance: 0,
        transactions: [],
      });

      console.log("User document set in Firestore");

      setShowModal(true);
      setModalMessage("You have been successfully issued an account");
      navigate("/verify-pin");
    } catch (error) {
      console.error("Error during Google signup:", error);
      setShowModal(true);
      setModalMessage(error.message);
    }
  };

  const handleSecurityQuestionChange = (index, value) => {
    const updatedQuestions = [...securityQuestions];
    updatedQuestions[index] = value;
    setSecurityQuestions(updatedQuestions);
  };

  const handleSecurityAnswerChange = (index, value) => {
    const updatedAnswers = [...securityAnswers];
    updatedAnswers[index] = value;
    setSecurityAnswers(updatedAnswers);
  };

  const handlePinChange = (index, value) => {
    const updatedPin = [...pin];
    updatedPin[index] = value;
    setPin(updatedPin);
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMessage("");
  };

  return (
    <>
      <div className="loginDiv">
        <form className="signup-form" onSubmit={handleSignup}>
          <div className="image-uploadd">
            <div className="frontText">
              <div className="signUpTitle">
                <h2>
                  Create an <span style={{ color: "#0D60D8" }}>UBS</span>{" "}
                  account
                </h2>
                <div className="signUpicon">
                  <img className="signUpicon" src={Emailer} alt="imailer" />
                </div>

                <div className="signUpicon">
                  <img className="signUpicon" src={FileMoney} alt="imailer" />
                </div>

                <div className="signUpicon">
                  <img className="signUpicon" src={Receipt} alt="imailer" />
                </div>
              </div>
              <p style={{ marginTop: 18 }}>
                UBS will help you manage your finances in a simple way.{" "}
                You have an account ? |
                <a className="llinkoo" href="/login">
                  Login Here
                </a>
              </p>

              <button
                onClick={handleGoogleSignup}
                className="google-signup-button"
              >
                <img
                  src={profileImag}
                  alt="Profile Preview"
                  style={{ width: 25, height: 25 }}
                />{" "}
                Signup with Google
              </button>

              <div
                style={{
                  color: "#00000050",
                  width: "90%",
                  margin: "5%",
                  textAlign: "center",
                }}
              >
                ------------------- Or --------------------
              </div>
            </div>
          </div>
          <div className="inHolderEmail">
            <img src={EmailIcon} alt="email" />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          <div className="inHolderEmail">
            <img src={Human} alt="email" />
            <input
              type="text"
              placeholder="Full Name"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </div>

          <div className="inHolderEmail" style={{ marginBottom: 30 }}>
            <img src={PassIcon} alt="email" />
            <input
              className="passwordd"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          {securityQuestions.map((question, index) => (
            <div className="security-questions" key={index}>
              <h3 style={{ marginBottom: 20, fontSize: 18 }}>
                Security Question{" "}
                <img
                  src={PassIcon}
                  alt="email"
                  style={{ width: "4%", marginLeft: 10 }}
                />{" "}
              </h3>
              <input
                style={{
                  borderWidth: 2,
                  marginBottom: 8,
                  borderColor: "#00000006",
                  borderStyle: "solid",
                }}
                type="text"
                placeholder={`Security Question ${index + 1}`}
                value={question}
                onChange={(e) =>
                  handleSecurityQuestionChange(index, e.target.value)
                }
              />
              <input
                style={{
                  borderWidth: 2,
                  borderColor: "#00000007",
                  borderStyle: "dashed",
                }}
                type="text"
                placeholder={`Security Answer ${index + 1}`}
                value={securityAnswers[index]}
                onChange={(e) =>
                  handleSecurityAnswerChange(index, e.target.value)
                }
              />
            </div>
          ))}
          <div className="pin-input-container">
            <div className="security-qs">
              <h3>Set your PIN</h3>
              <img
                src={Keyy}
                alt="email"
                style={{ width: 19, marginLeft: 10 }}
              />
            </div>
            <div className="pin-inputs">
              {pin.map((digit, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength={1}
                  value={digit}
                  onChange={(e) => handlePinChange(index, e.target.value)}
                  className="pin-input"
                />
              ))}
            </div>
            <button className="input" type="submit">
              Signup
            </button>
            <p style={{textAlign: 'center', color: '#00000069', padding: 2, fontSize: 15}} >
              Secured by UBS banking service <img style={{width: 15}} src={Lock} alt="" />
              <img style={{width: 14, marginLeft: 4,}} src={Verii} alt="" />
            </p>
          </div>
        </form>

        {showModal && (
          <div className="modal">
            <div className="modal-content">
              {/* <img src={Veri} alt="hhk" style={{width: 60, height: 60}} /> */}
              <p style={{ width: "90%" }}>{modalMessage}</p>
              <span className="close" onClick={closeModal}>
                Okay
              </span>
            </div>
          </div>
        )}

        <div className="stratight"></div>
      </div>
    </>
  );
};

export default Signup;
